import React from 'react'
import store from "../../../redux/store";
import { toAbsoluteUrl } from "../../../Utils/_helpers";
import * as callService from "../Ticker/CallService";
import { getCallConferenceAgent, getCallTransferAgent } from './api';
const eventKeyMap = {
  invited: "AGENT_CALL",
  agent_ack: "AGENT_ANSWER",
  ack: "CUSTOMER_CALL",
  info: "CUSTOMER_ANSWER",
  hangup: "HANGUP"
};

const inboundEventKeyMap = {
  invited: "ORIGINATE",
  info: "ANSWER",
  hangup: "HANGUP"
};

const callSolutionMap = {
  'ibd': 'inbound',
  'ibdcc': 'inbound',
  'sequential': 'obdcc',
  'predictive': 'obdcc'
};

export function getSetting(key) {
  const auth = store.getState().auth;

  return auth[key];
}

export function getSessionUserId() {
  const auth = store.getState().auth;

  return auth.user.user_id;
}

export const getAgentPhoneForCallingKrmId = (agent) => {
  if (agent && agent["source"] === "external") {
    return agent["phone"];
  }
  if (!agent) return "";
  return agent.krm_agent_id;
};

export const getAgentPhoneForCalling = (agent, maxLength) => {
  if (agent && agent["source"] === "external") {
    return agent["phone"];
  }

  let value = "-";
  if (!agent) return value;
  if (agent.sip_url_flag) {
    value = agent.phone;
  } else {
    value = `${agent.country_code}${agent.phone}`;
  }

  if (maxLength && value.length > maxLength) {
    value = value.substring(0, maxLength) + "..";
  }
  return value;
};

export const getAgentPhone = (agent, maxLength) => {
  if (agent && agent["source"] === "external") {
    return agent["phone"];
  }
  let value = "-";
  if (agent.sip_url_flag) {
    value = agent.phone;
  } else {
    value = `${agent.country_code} ${agent.phone}`;
  }

  if (maxLength && value.length > maxLength) {
    value = value.substring(0, maxLength) + "..";
  }
  return value;
};

export const getName = (agent, maxLength) => {
  let list = [];
  if (agent.first_name) list.push(agent.first_name);
  if (agent.last_name) list.push(agent.last_name);
  if (list.length === 0) return "Unknown";
  let name = list.join(" ");
  if (maxLength && name.length > maxLength) {
    name = name.substring(0, maxLength) + "..";
  }
  return name;
};

export const getNameInitial = (agent) => {
  if (agent.first_name) return agent.first_name[0].toUpperCase();
  return "U";
};

export const getStatusClass = (status) => {
  if (!status) return "status-not-available";
  let st = status.toLowerCase();
  st = st.replaceAll(" ", "");
  switch (st) {
    case "available":
      return "status-available";
    case "notavailable":
      return "status-not-available";
    case "onbreak":
      return "status-onbreak";
    case "loggedout":
      return "status-not-available";
    case "oncall":
      return "status-oncall";
    default:
      return "status-not-available";
  }
};

export const getSortedAgentList = (list, key = "agent_status") => {
  let obj = {};
  list.forEach((item, index) => {
    if (!item[key]) {
      if (!obj["status-not-available"]) {
        obj["status-not-available"] = [item];
      } else {
        obj["status-not-available"] = [...obj["status-not-available"], item];
      }
    } else if (obj[item[key].toLowerCase().replaceAll(" ", "")]) {
      obj[item[key].toLowerCase().replaceAll(" ", "")].push(item);
    } else {
      obj[item[key].toLowerCase().replaceAll(" ", "")] = [item];
    }
  });
  let list2 = [];
  if (obj["available"]) {
    list2 = [...list2, ...obj["available"]];
  }
  if (obj["onbreak"]) {
    list2 = [...list2, ...obj["onbreak"]];
  }
  if (obj["notavailable"]) {
    list2 = [...list2, ...obj["notavailable"]];
  }
  if (obj["loggedout"]) {
    list2 = [...list2, ...obj["loggedout"]];
  }
  if (obj["status-not-available"]) {
    list2 = [...list2, ...obj["status-not-available"]];
  }
  if (obj["oncall"]) {
    list2 = [...list2, ...obj["oncall"]];
  }
  return list2;
};

export const GetQueuePhotoOrInitial = (props) => {
  return (
    <>
      {props.agent.img && (
        <div className={props.wrapCls}>
          <img
            alt=""
            className={props.imgCls}
            src={toAbsoluteUrl(props.agent.img)}
          />
        </div>
      )}
      {!props.agent.img && (
        <div className={props.wrapCls}>
          <div
            className={
              getStatusClass(props.agent.agent_status) +
              " " +
              props.imgCls +
              " "
            }
          >
            <span className="d-flex justify-content-center dp-label">
              {getNameInitial(props.agent)}
            </span>
          </div>
        </div>
      )}
    </>
  );
};

export const GetAgentPhotoOrInitial = (props) => {
  return (
    <>
      {props.agent.img && (
        <div className={props.wrapCls}>
          <img
            alt=""
            className={props.imgCls}
            src={toAbsoluteUrl(props.agent.img)}
          />
        </div>
      )}
      {!props.agent.img && (
        <div className={props.wrapCls}>
          <span className={props.imgCls}>{getNameInitial(props.agent)}</span>
        </div>
      )}
    </>
  );
};
export const getAgentPhotoOrInitial = (props) => {
  return (
    <div className="queue-dp-sec">
      <div className="queue-dp">
        <span className="d-flex justify-content-center dp-label">
          {getNameInitial(props.agent)}
        </span>
      </div>
    </div>
  );
};

const getMaskedCustomerNumber = (cust_num) => {
  
  const { number_masking, number_masking_format, remove_konnect_dependency } = store.getState().auth;
  const maskedLength = parseInt(number_masking_format);
  
  if (cust_num.includes('#') || !number_masking) {
    return cust_num;
  }

  if (number_masking && remove_konnect_dependency) {
    if (maskedLength === 0) {
      return cust_num;
    }

    if (maskedLength > 0 && maskedLength <= cust_num.length) {
      const num = cust_num.substring(0, maskedLength).replace(/\d/g, '#');
      return num + cust_num.substring(maskedLength)
    }

    if (maskedLength < 0 && maskedLength <= cust_num.length) {
      const num = cust_num.substring(cust_num.length - Math.abs(maskedLength)).replace(/\d/g, '#');
      return cust_num.substring(0, cust_num.length - Math.abs(maskedLength)) + num;
    }
  }
  return cust_num;
}

export const eventEngineDataObject = (data, refer = {}, oldLegBuuid = '') => {
  const ticker = store.getState().ticker;
  const key = Object.keys(data)[0];
  const value = data[key];
  let eventPacket = { ...value, ...refer };

  const mapAdditionalInfo = (additionalInfoStr) => {
    return additionalInfoStr.split(",").reduce((obj, pair) => {
      let [key, value] = pair.split(":");
      if (value === 'attxfer' || value === 'legcbridge' || value === 'legcanswer') value = 'att_xfer';
      if (value == 'bridgeconf') value = 'bdtmf';
      obj[key] = value;
      return obj;
    }, {});
  };

  const additionalInfo = (key === "info") && mapAdditionalInfo(eventPacket.additionalinfo);

  const call_solution = callSolutionMap[eventPacket.Callsolution] || eventPacket.Callsolution;
  const call_direction = call_solution === 'inbound' ? 'Inbound' : call_solution === 'c2c' ? 'Outbound' : call_solution;
  const selectedKeyMap = call_solution === 'inbound' ? inboundEventKeyMap : call_solution === 'c2c' ? eventKeyMap : eventKeyMap;
  const legCHangup = (key === "info" && additionalInfo['additionalinfo'] === 'legcdisconnect') && 'HANGUP';
  const predictiveBridge = (key === "info" && eventPacket.Callsolution === 'predictive' && additionalInfo['additionalinfo'] === 'unbridge')
  ? 'HANGUP' : (key === "info" && eventPacket.Callsolution === 'predictive') ? 'BRIDGE' : null;
  const obdccAgentAnswer = (key === "info" && eventPacket.Callsolution === 'sequential' && additionalInfo['additionalinfo'] === 'att_xfer') && 'AGENT_ANSWER';
  const legCAgent = key == "hangup" ? null : (getCallTransferAgent()?.contact_number || getCallConferenceAgent()?.contact_number);
  const deleteLegCuuid = (key === "info" && (eventPacket.additionalinfo?.split(",")[0].includes('attxfer') || eventPacket.additionalinfo?.split(",")[0].includes('legcbridge')));
  const legcBDTMF = (key === "info" && eventPacket.additionalinfo?.split(",")[0].includes('legcanswer')) && "bdtmf";
  const customernum = (key === "info" && eventPacket.Callsolution === 'predictive' && (additionalInfo['additionalinfo'] === 'bridge' || additionalInfo['additionalinfo'] === 'unbridge') 
  && additionalInfo['customernum']) ? additionalInfo['customernum'] : eventPacket?.Customernum;
  if(legCHangup || deleteLegCuuid) { sessionStorage.removeItem('legcuuid'); }

  if (!selectedKeyMap[key]) return null;

  return {
    [key]: {
      ...(key !== "invited" && { ...value }),
      "event_type": legCHangup || obdccAgentAnswer || predictiveBridge || selectedKeyMap[key],
      "agent_number": legCAgent || (callSolutionMap[eventPacket.Callsolution] === 'obdcc' 
      ? getAgentPhoneForCalling(ticker?.session_agent) : 
      `${eventPacket?.Agentusername}@${eventPacket?.Agentdomain}`),
      "knowlarity_number": eventPacket?.Srnum,
      "uuid": eventPacket?.Calluuid,
      "caller": getMaskedCustomerNumber(customernum),
      "customer_number": getMaskedCustomerNumber(customernum),
      "k_number": eventPacket?.Srnum,
      "type": legCHangup || obdccAgentAnswer || predictiveBridge || selectedKeyMap[key],
      "unique_id": callSolutionMap[eventPacket.Callsolution] === 'obdcc'
      ? (oldLegBuuid || additionalInfo["legbuuid"] || eventPacket?.Channeluuid).split('_')[0]
      : oldLegBuuid || additionalInfo["legbuuid"] || eventPacket?.Channeluuid,
      "call_solution": call_solution,
      "FreeSWITCH_IPv4": eventPacket?.Fs,
      "variable_sip_call_id": eventPacket["Call-ID"],
      "call_direction": call_direction,
      "variable_current_application": additionalInfo['additionalinfo'],
      "variable_current_application_type": legcBDTMF || additionalInfo['additionalinfo'] || 'bdtmf',
      ...((eventPacket?.Callsolution === 'ibdcc' || callSolutionMap[eventPacket.Callsolution] === 'obdcc') && 
      { "variable_cc_queue": (eventPacket?.Queue || '6975a212-fe30-4491-b3ee-90475b37a6c4')}),
      ...(additionalInfo['additionalinfo'] === 'att_xfer' && { "Other_Leg_Unique_ID" : additionalInfo["legbuuid"] || eventPacket?.Calluuid }),
      ...((eventPacket?.Callsolution === 'predictive' && additionalInfo['additionalinfo'] == 'unbridge') && { "leg_identifier": "customer" })
    }
  };
};

export const callSIPEventEngine = async (event, dispatch) => {
  let params = { handleMessage: callService.handleCallServiceMessage };
  return await callService.handleCallServiceMessage(event, params, dispatch);
}